import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { payInvoices } from "@galarson/Handlers/PayInvoicesServices";

export const RequestApiCall = async () => {
    const restult = await payInvoices();
    if (restult !== "") {
        window.location.href = restult;
    } 
};

export const chain = [RequestApiCall];

const InvoicePay = createHandlerChainRunner(chain, "payInvoice");
export default InvoicePay;
